<template>
  <Transition name="fade">
    <div
      v-if="!isImageMode && windowSize.width < windowSize.height" class="icon_buttons"
      :class="{'opacity': disabledQualification()}"
    >
      <template v-if="accessedMemberInfo.name">
        <button
          type="button" :class="{ 'account_btn' : showPanel.isMobileAccountInfo }"
          :disabled="disabledQualification()"
          @click="showMobileAccountToggle"
        >
          <span>
            <AccountSvg />
          </span>
          ACCOUNT
        </button>
        <button
          type="button"
          :disabled="disabledQualification()"
          @click="submitLogout"
        >
          <span>
            <LogoutSvg />
          </span>
          LOGOUT
        </button>
      </template>
      <button
        v-else type="button"
        :class="{ 'login_button_active' : showPanel.isLogin }"
        :disabled="disabledQualification()"
        @click="showLoginToggle"
      >
        <span>
          <LoginSvg />
        </span>
        LOGIN
      </button>
      <button
        v-if="!isImageMode" type="button"
        :disabled="disabledQualification()"
        @click="imageModeToggle"
      >
        <span>
          <ImageModeSvg />
        </span>
        IMAGE MODE
      </button>
    </div>
  </Transition>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';


import AccountSvg from '@/assets/images/Svgs/AccountSvg.vue';
import ImageModeSvg from '@/assets/images/Svgs/ImageModeSvg.vue';
import LoginSvg from '@/assets/images/Svgs/LoginSvg.vue';
import LogoutSvg from '@/assets/images/Svgs/LogoutSvg.vue';
import useCommonStore from '@/store/storeCommon';
import useMemberStore from '@/store/storeMember';


const { isImageMode } = storeToRefs(useCommonStore());
const {
  imageModeToggle,
  showLoginToggle,
  disabledQualification,
  windowSize,
  showPanel,
} = useCommonStore();
const { accessedMemberInfo, accessLogout } = useMemberStore();

const showMobileAccountToggle = (): void => {
  showPanel.isMobileAccountInfo = !showPanel.isMobileAccountInfo;
};

/**
 * 로그아웃 기능을 실행합니다.
 */
const submitLogout = (): void => {
  accessLogout();

  if (showPanel.isEditPassword) {
    showPanel.isEditPassword = false;
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/css/_colors.scss';

.icon_buttons {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 13.2px 0 33.7px;
  position: absolute;
  z-index: 200;
  pointer-events: auto;

  &.opacity {
    opacity: 0.3;
  }

  button {
    width: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 3.8px;
    font-size: 8px;
    fill: $color-white;
    color: $color-white;
    transition: 0.3s;

    span {
      display: flex;
      align-items: center;
      height: 100%;
    }

    &.login_button_active {
      fill: $color-debra;
      color: $color-debra;
    }

    &.account_btn {
      fill: $color-debra;
      color: $color-debra;
    }
  }
}

// tablet
@media screen and (min-width: 500px) and (min-height: 500px) {
  .layout {
    .mobile_logined_account_inner {
      .icon_buttons {
        &.mobile_account_btn {
          padding-bottom: 20px;
        }
      }
    }
  }
}
</style>